import { render, staticRenderFns } from "./tendero.vue?vue&type=template&id=c3d94cce&scoped=true&"
import script from "./tendero.vue?vue&type=script&lang=js&"
export * from "./tendero.vue?vue&type=script&lang=js&"
import style0 from "./tendero.vue?vue&type=style&index=0&id=c3d94cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d94cce",
  null
  
)

export default component.exports